import { AbstractControl, ValidationErrors } from '@angular/forms';

export function rxNumericCheckValidator(control: AbstractControl): ValidationErrors | null {
  if (/[^\d]/g.test(control.value)) {
    return { phone: true };
  }
  return null;
}
